import type { DemoScript } from "../types";
import { PROPOSALS_SCRIPT_COPY } from "./proposals-script.copy";

/**
 * Roteiro da mesma aba em conta de Collab, onde a rota entrega a lista de
 * propostas. Sem os passos de modal do roteiro da calculadora: aquele modal é
 * o de precificar uma publi, que não é a tela aqui.
 */
export const buildProposalsScript = (): DemoScript => [
  {
    id: "prop-intro",
    narrative: PROPOSALS_SCRIPT_COPY.propIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "prop-toolbar",
    narrative: PROPOSALS_SCRIPT_COPY.propToolbar.narrative,
    zoomTargetId: "calc-toolbar",
    disableZoom: true,
    callout: {
      targetId: "calc-toolbar",
      text: PROPOSALS_SCRIPT_COPY.propToolbar.callout,
    },
    durationMs: 5200,
  },
  {
    id: "prop-overview",
    narrative: PROPOSALS_SCRIPT_COPY.propOverview.narrative,
    durationMs: 1800,
  },
  {
    id: "prop-cards",
    narrative: PROPOSALS_SCRIPT_COPY.propCards.narrative,
    zoomTargetId: "calc-cards",
    callout: {
      targetId: "calc-cards",
      text: PROPOSALS_SCRIPT_COPY.propCards.callout,
    },
    durationMs: 5800,
  },
  {
    id: "prop-converted",
    narrative: PROPOSALS_SCRIPT_COPY.propConverted.narrative,
    zoomTargetId: "calc-cards",
    callout: {
      targetId: "calc-cards",
      text: PROPOSALS_SCRIPT_COPY.propConverted.callout,
    },
    durationMs: 5200,
  },
];
